<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Art Director: Kristy Zacharias</p>
<p class="copy">Editors: Lynn Koolish and Deb Rowden</p>
<p class="copy">Technical Editors: Debbie Rodgers and Gailen Runge</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Rue Flaherty</p>
<p class="copy">Production Editor: Joanna Burgarino</p>
<p class="copy">Illustrator: Kirstie L. Petterson</p>
<p class="copy">Photo Assistant: Mary Peyton Peppo</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyright.vue?70725074